// extracted by mini-css-extract-plugin
module.exports = {"heading":"i_Gg","container":"i_Gh"};